import { useEffect } from 'react';
import { useLazyGetMilestoneProgresDataQuery } from 'src/services/MilestoneTracking';
import { useAppDispatch } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';

export const useProgress = () => {
  const dispatch = useAppDispatch();

  const [getMilestoneProgresData, { isLoading: progressDataLoading, data: progressData, error: progressDataError }] =
    useLazyGetMilestoneProgresDataQuery();
  useEffect(() => {
    if (progressDataError) {
      updateUserAccess(progressDataError, dispatch);
    }
  }, [progressDataError]);
  return { progressDataLoading, progressData, progressDataError, getMilestoneProgresData };
};
